export default __webpack_public_path__ + "static/media/5.3d09a5fd.jpg";